module.exports = __webpack_public_path__ + "static/robinhood-a17db67cabe989d48dc324c76ce6b46e.png";